var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"#D1FAE5","key":0}),React.createElement("path",{"d":"M8.43667 10.1524L7.02246 11.5666L11.9722 16.5163L19.0433 9.44528L17.6291 8.03107L11.9722 13.6879L8.43667 10.1524Z","fill":"#059669","key":1})]);
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Check;

Check.default = Check;
